import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'reactstrap/lib/Button';
import { Link } from 'site-modules/shared/components/link/link';

export function CardNameWrapper({
  link,
  onRemove,
  className,
  titleClassName,
  nameClassName,
  nameText,
  trackingId,
  linkRel,
  hideRemoveButton,
}) {
  const { url, text } = link;

  return (
    <div className={classnames('comparator-card-name d-flex justify-content-between align-items-start', className)}>
      <div>
        <Link to={url} rel={linkRel} data-tracking-id={trackingId} className={classnames('card-name', titleClassName)}>
          {text} {!!url && <span className="visually-hidden">View vehicle details</span>}
        </Link>
        {!!nameText && (
          <div className={nameClassName} aria-hidden>
            {nameText}
          </div>
        )}
      </div>
      {!hideRemoveButton && (
        <Button
          color="link"
          className="remove-btn text-decoration-none size-16 p-0 ms-0_5"
          onClick={onRemove}
          aria-label={`Remove ${text} from comparison`}
        >
          <span className="icon-cross2" aria-hidden />
        </Button>
      )}
    </div>
  );
}

CardNameWrapper.propTypes = {
  onRemove: PropTypes.func.isRequired,
  link: PropTypes.shape({
    url: PropTypes.string,
    text: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
  nameText: PropTypes.string,
  trackingId: PropTypes.string,
  linkRel: PropTypes.string,
  hideRemoveButton: PropTypes.bool,
  titleClassName: PropTypes.string,
  nameClassName: PropTypes.string,
};

CardNameWrapper.defaultProps = {
  className: null,
  nameText: null,
  trackingId: null,
  linkRel: null,
  hideRemoveButton: false,
  titleClassName: 'heading-5 text-primary-darker',
  nameClassName: 'medium',
};
